"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Advertisement.default;
  }
});

var _Advertisement = _interopRequireDefault(require("./Advertisement"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/views/Advertisement/index.js
 ** module id = 2213
 ** module chunks = 0
 **/